import React, { useEffect } from 'react';

const GAME_KEYS = ['C', 'V', 'N', 'M'];

const Confirmation = ({ setIsNextDisabled, startGame }) => {
  useEffect(() => {
    if (!startGame) return;
    const handleKey = (e) => {
      const key = e.key.toUpperCase();
      if (e.key === 'Enter' || GAME_KEYS.includes(key)) {
        e.preventDefault();
        document.removeEventListener('keydown', handleKey);
        startGame();
      }
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [startGame]);

  return (
    <div className="game-instruction-container">
      <div className="game-instruction-content">
        <div className="game-instruction-text">
          Now, it's time to play the full game. This will take about 10 minutes. Keep going until you reach the end.
          <br />Make sure you keep your fingers on the correct keys. If you don't press the key fast enough, the light will move to a new position.
        </div>
        <div className="game-instruction-text confirmation-start-hint">
          Press C, V, N, or M to start the game. You can also click Begin or press Enter.
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
